<nz-affix [nzOffsetTop]="0">
  <nz-page-header [nzGhost]="false">
    <nz-page-header-title>{{'compositeProducts.title' | transloco}}</nz-page-header-title>
    <nz-page-header-subtitle>{{'compositeProducts.subTitle' | transloco}}</nz-page-header-subtitle>
    <nz-page-header-extra>
      <a routerLink="new" nz-button nzType="primary">
        <i nz-icon nzType="plus-circle" nzTheme="outline"></i> {{'compositeProducts.button.addNew' | transloco}}
      </a>
    </nz-page-header-extra>
    <nz-page-header-footer>
      <hc-catalog-tabs></hc-catalog-tabs>
    </nz-page-header-footer>
  </nz-page-header>
</nz-affix>

@if (summary) {
  <div class="cp__summary">
    <span>{{ 'compositeProducts.list.summary.cards' | transloco }}: <b>{{ summary.cards }}</b></span>
    <button class="cp__summary-link" nz-button nzType="link" nzSize="small" type="button" (click)="showOnly('no_section')">
      {{ 'compositeProducts.list.summary.withoutSection' | transloco }}:&nbsp;<b>{{ summary.cardsWithoutSection }}</b>
    </button>
    <button class="cp__summary-link" nz-button nzType="link" nzSize="small" type="button" (click)="showOnly('no_address')">
      {{ 'compositeProducts.list.summary.withoutAddress' | transloco }}:&nbsp;<b>{{ summary.cardsWithoutAddress }}</b>
    </button>
  </div>
}

@if (selectedIds.length > 0) {
  <div class="cp__bulk">
    <span>{{ 'compositeProducts.list.selected' | transloco }}: <b>{{ selectedIds.length }}</b></span>
    @if (me.admin) {
      <button nz-button nzType="primary" type="button" (click)="openAssign()">
        <i nz-icon nzType="folder-add" nzTheme="outline"></i> {{ 'compositeProducts.list.toSection' | transloco }}
      </button>
    }
    <button nz-button nzType="link" type="button" (click)="clearSelection()">{{ 'compositeProducts.list.clearSelection' | transloco }}</button>
  </div>
}

<nz-table [nzLoading]="isTableLoading" #compositeProductsTable
          [nzTotal]="total"
          [nzPageSize]="limit"
          [nzPageIndex]="page"
          [nzData]="list"
          (nzQueryParams)="onQueryParamsChange($event)"
          [nzFrontPagination]="false">
  <thead>
  <tr>
    @if (me.admin) {
      <th nzWidth="46px" [nzShowCheckbox]="true" [nzChecked]="allChecked" [nzIndeterminate]="someChecked" (nzCheckedChange)="checkAll($event)"></th>
    }
    <th nzColumnKey="title" [nzSortOrder]="columnSortOrderMap.get('title') || null" [nzSortFn]="true" [nzSortPriority]="1">{{'compositeProducts.column.title' | transloco}}</th>
    <th nzCustomFilter>
      {{'compositeProducts.column.country' | transloco}}
      <nz-filter-trigger [(nzVisible)]="countryFilter.isVisible" [nzActive]="countryFilter.isActive" [nzDropdownMenu]="countryFilterMenu">
        <i nz-icon nzTheme="fill" nzType="filter"></i>
      </nz-filter-trigger>
    </th>
    <th nzCustomFilter>
      {{'compositeProducts.column.section' | transloco}}
      <nz-filter-trigger [(nzVisible)]="sectionFilter.isVisible" [nzActive]="sectionFilter.applied !== 'all'" [nzDropdownMenu]="sectionFilterMenu">
        <i nz-icon nzTheme="fill" nzType="filter"></i>
      </nz-filter-trigger>
    </th>
    <th>{{'compositeProducts.column.slug' | transloco}}</th>
    <th nzColumnKey="type" [nzSortOrder]="columnSortOrderMap.get('type') || null" [nzSortFn]="true" [nzSortPriority]="2">{{'compositeProducts.column.type' | transloco}}</th>
    <th nzColumnKey="price" [nzSortOrder]="columnSortOrderMap.get('price') || null" [nzSortFn]="true" [nzSortPriority]="3">{{'compositeProducts.column.price' | transloco}}</th>
    <th nzCustomFilter>
      {{'compositeProducts.column.tags' | transloco}}
      <nz-filter-trigger [(nzVisible)]="tagsFilter.isVisible" [nzActive]="tagsFilter.isActive" [nzDropdownMenu]="tagsFilterMenu">
        <i nz-icon nzTheme="fill" nzType="filter"></i>
      </nz-filter-trigger>
    </th>
    <th nzColumnKey="products">{{'compositeProducts.column.products' | transloco}}</th>
    <th nzWidth="100px">#</th>
  </tr>
  </thead>
  <tbody>
  @for (data of list; track data.id) {
    <tr>
      @if (me.admin) {
        <td [nzShowCheckbox]="true" [nzChecked]="data.checked" (nzCheckedChange)="check(data, $event)"></td>
      }
      <td>{{ data.title | uiLabel }}</td>
      <td>{{ data.countryTitle }}</td>
      <td>
        @if (data.sectionTitle) {
          {{ data.sectionTitle }}
          @if (data.sectionDraft) {
            <nz-tag nzColor="default">{{ 'compositeProducts.sections.draft' | transloco }}</nz-tag>
          }
        } @else {
          <span class="cp__muted">—</span>
        }
      </td>
      <td>
        @if (data.slug) {
          <code>{{ data.slug }}</code>
        } @else {
          <span class="cp__muted">—</span>
        }
      </td>
      <td>{{ data.typeKey | transloco }}</td>
      <td>{{ data.price }}</td>
      <td>
        @for (label of data.labels; track label.code) {
          <nz-tag [nzColor]="label.color">{{ label.text }}</nz-tag>
        }
      </td>
      <td>{{ data.subProductTitles }}</td>
      <td>
        <nz-button-group>
          <button [routerLink]="data.id + '/edit'" nz-button nzType="primary">
            <i nz-icon nzType="edit" nzTheme="outline"></i>
          </button>
          <button nz-button nzType="default" nzDanger nz-popconfirm
                  [nzPopconfirmTitle]="'remove.popconfirm' | transloco" [nzOkText]="'yes' | transloco"
                  [nzCancelText]="'no1' | transloco"
                  (nzOnConfirm)="remove(data)">
            <i nz-icon nzType="delete" nzTheme="outline"></i>
          </button>
        </nz-button-group>
      </td>
    </tr>
  }
  </tbody>
</nz-table>

<nz-dropdown-menu #countryFilterMenu>
  <div class="cp__filter ant-table-filter-dropdown">
    <nz-checkbox-group [(ngModel)]="countryFilter.options"></nz-checkbox-group>

    <div class="ant-table-filter-dropdown-btns">
      <button (click)="resetFilter(countryFilter)" nz-button nzType="link" nzSize="small" tabindex="-1">Сбросить</button>

      <nz-radio-group nzName="countryFilterOperator" [(ngModel)]="countryFilter.operator" nzSize="small">
        <label nz-radio-button nzValue="or">или</label>
        <label nz-radio-button nzValue="and">и</label>
      </nz-radio-group>

      <button (click)="applyFilter(countryFilter)" nz-button nzType="primary" nzSize="small">OK</button>
    </div>
  </div>
</nz-dropdown-menu>

<nz-dropdown-menu #sectionFilterMenu>
  <div class="cp__filter ant-table-filter-dropdown">
    <nz-radio-group class="cp__radios" nzName="sectionFilter" [(ngModel)]="sectionFilter.selected">
      <label nz-radio nzValue="all">{{ 'compositeProducts.filter.all' | transloco }}</label>
      <label nz-radio nzValue="no_section">{{ 'compositeProducts.filter.noSection' | transloco }}</label>
      <label nz-radio nzValue="no_address">{{ 'compositeProducts.filter.noAddress' | transloco }}</label>
      @for (option of sectionFilter.options; track option.value) {
        <label nz-radio [nzValue]="option.value">{{ option.label }}</label>
      }
    </nz-radio-group>

    <div class="ant-table-filter-dropdown-btns">
      <button (click)="resetSectionFilter()" nz-button nzType="link" nzSize="small" tabindex="-1">Сбросить</button>
      <button (click)="applySectionFilter()" nz-button nzType="primary" nzSize="small">OK</button>
    </div>
  </div>
</nz-dropdown-menu>

<nz-dropdown-menu #tagsFilterMenu>
  <div class="cp__filter ant-table-filter-dropdown">
    <nz-checkbox-group [(ngModel)]="tagsFilter.options"></nz-checkbox-group>

    <div class="ant-table-filter-dropdown-btns">
      <button (click)="resetFilter(tagsFilter)" nz-button nzType="link" nzSize="small" tabindex="-1">Сбросить</button>

      <nz-radio-group nzName="tagsFilterOperator" [(ngModel)]="tagsFilter.operator" nzSize="small">
        <label nz-radio-button nzValue="or">или</label>
        <label nz-radio-button nzValue="and">и</label>
      </nz-radio-group>

      <button (click)="applyFilter(tagsFilter)" nz-button nzType="primary" nzSize="small">OK</button>
    </div>
  </div>
</nz-dropdown-menu>
